<template>
  <v-card fill-height style="max-height:300px;min-height:250px;margin:5px;" @click="selVessel">
    <v-card-title style="height:10%;color:rgb(144,170,218);">
      <div primary class="title">{{ cardData.name }}</div>
      <v-spacer/>
    </v-card-title>

    <v-card-actions fill-height style="height:80%;">
      <v-container fluid grid-list-md style="padding:5px;height:100%;">
        <v-layout row fill-height>
          <v-flex d-flex md3>
            <v-layout column fill-height>
              <v-flex d-flex md1 class="clickable" @click='goToVessel()'>{{ cardData.vessel }}</v-flex>
              <v-flex d-flex md10>
                <v-layout row>
                  <v-flex d-flex md4>
                    <div v-if="cardData.engineKPI<0" style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:20px;">-</div>
                    <div v-else-if="cardData.engineColor==20" style="color:rgb(205, 57, 64);display:flex;align-items:center;justify-content:center;font-size:20px;">{{ cardData.engineKPI }} %</div>
                    <div v-else style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:20px;">{{ cardData.engineKPI }} %</div>
                  </v-flex>
                  <v-flex d-flex md8 style="align-items:center;">
                    <div v-if="cardData.engineColor==0" :style="'height:25px; border:none; color:rgb(60, 171, 48); background-color:rgb(60, 171, 48); width:' + cardData.engineKPI+ '%;' "/>
                    <div v-if="cardData.engineColor==10" :style="'height:25px; border:none; color:rgb(255, 184, 29); background-color:rgb(255, 184, 29); width:' + cardData.engineKPI+ '%;' "/>
                    <div v-if="cardData.engineColor==20" :style="'height:25px; border:none; color:rgb(205, 57, 64); background-color:rgb(205, 57, 64); width:' + cardData.engineKPI+ '%;' "/>
                    <div :style="'height:25px; border:none; color:rgb(244,244,244);  background-color:rgb(244,244,244); width:' + (100-cardData.engineKPI)+ '%;' "/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md1 style="align-items:center;font-size:16px;color:rgb(118,118,118);">Engine KPI</v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <v-layout column style="margin:0px;">
              <v-flex d-flex md4>
                <v-layout v-if="cardData.fault.last" row style="align-items:center;">
                  <div style="font-size:20px;">{{ cardData.fault.last }}</div>
                </v-layout>
                <v-layout v-else row style="align-items:center;">
                  <div style="font-size:20px;">-</div>
                </v-layout>
              </v-flex>
              <v-flex d-flex md2 style="color:rgb(118,118,118);">Last fault</v-flex>
              <v-flex v-if="cardData.fault.top" d-flex md4 style="font-size:20px;align-items:flex-end;">{{ cardData.fault.top }}</v-flex>
              <v-flex v-else d-flex md4 style="font-size:20px;align-items:flex-end;">
                <div>-</div>
              </v-flex>
              <v-flex d-flex md2 style="color:rgb(118,118,118);">Most frequent fault</v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['bsfc']"/>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['sloc']"/>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-layout column>
            <div style="text-align: right; margin-top: 1rem; padding-right: 20px">
                            <span
                                class="show_ticket"
                                style="max-width: 90px; text-align: center; color: rgb(144, 170, 218); font-weight: 500; border-bottom: 1px solid rgb(144, 170, 218); padding-bottom: 1px;">Show tickets</span>
            </div>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>

import Trendline from './Trendline'
import {store} from "../main.js";

export default {
  name: "EngineCard",
  components: {
    Trendline
  },
  props: {
    cardData: Object
  },
  data: function () {
    return {}
  },
  mounted() {
  },
  methods: {
    goToVessel() {
      window.$cookies.set('vessel', this.cardData.vessel);
      let vessel_url = new URL(store.config.ship_co)
      vessel_url.pathname += `vessel-view/${this.cardData.vessel}`
      window.open(vessel_url.toString());
    },
    selVessel() {
      store.selectedTicketsVessel = this.cardData.vessel;
    }
  },
  watch: {}
}
</script>

<style scoped>
.show_ticket {
  max-width: 90px;
  text-align: center;
  color: rgb(144, 170, 218);
  font-weight: 500;
  border-bottom: 1px solid rgb(144, 170, 218);
  padding-bottom: 1px;
}

.show_ticket:hover {
  cursor: pointer;
}
</style>


